import React from "react";

const LabServiceWaves = ({ className }) => {
  return (
    <svg
      className={className}
      width="100%"
      height="100%"
      viewBox="0 0 1440 400"
      preserveAspectRatio="none"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.23"
        d="M395.434 141.89C417.35 129.033 424.991 100.439 408.056 81.4963C384.826 55.5103 355.882 34.9576 323.258 21.6015C276.348 2.39688 224.429 -0.864678 175.485 12.3185C126.54 25.5016 83.2828 54.3993 52.3651 94.5667C21.4475 134.734 4.58225 183.946 4.36349 234.634C4.14472 285.322 20.5845 334.679 51.1543 375.111C81.7241 415.544 124.731 444.814 173.559 458.419C222.388 472.024 274.334 469.211 321.407 450.412C354.145 437.338 383.265 417.036 406.719 391.251C423.817 372.455 416.423 343.797 394.619 330.751V330.751C372.815 317.706 344.895 325.637 325.482 342.031C314.137 351.612 301.257 359.38 287.282 364.961C258.937 376.281 227.658 377.975 198.256 369.782C168.854 361.59 142.958 343.965 124.551 319.619C106.143 295.273 96.2442 265.553 96.376 235.032C96.5077 204.51 106.663 174.877 125.28 150.691C143.897 126.504 169.944 109.103 199.415 101.165C228.887 93.2272 260.15 95.1911 288.396 106.755C302.322 112.456 315.135 120.335 326.398 130.014C345.668 146.574 373.518 154.746 395.434 141.89V141.89Z"
        fill="url(#paint0_linear_244_12528)"
      />
      <path
        opacity="0.2"
        d="M1063.48 84.9515C971.08 106.552 916.647 38.6182 900.98 1.95154H1424.98V84.9515C1390.98 109.285 1320.58 147.752 1310.98 106.952C1298.98 55.9515 1178.98 57.9515 1063.48 84.9515Z"
        fill="#DDCAEB"
      />
      <path
        opacity="0.2"
        d="M544.98 427.452C490.98 394.652 445.314 433.452 425.48 470.952H966.98L964.828 469.802C932.133 452.335 912.725 441.967 900.98 428.657C885.98 411.657 773.98 396.952 736.48 444.452C698.98 491.952 612.48 468.452 544.98 427.452Z"
        fill="#DDCAEB"
      />
      <defs>
        <linearGradient
          id="paint0_linear_244_12528"
          x1="420.118"
          y1="370.508"
          x2="114.719"
          y2="36.7609"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#7F4A9B" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LabServiceWaves;
